import React, { useEffect, useState } from 'react';
import { Card, Typography, Grid, Tabs, Tab, Box, useMediaQuery, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import ErrorOutline from '@mui/icons-material/ErrorOutline';

const TabButton = ({ index, label, onTabChange, onClick, isSelected }) => {
  return (
    <Tab
      key={index}
      label={label}
      value={index}
      onClick={() => {
        onTabChange(index);
        onClick();
      }}
      sx={{
        fontSize: 12,
        fontWeight: '600',
        backgroundColor: isSelected ? '#F59C1E' : 'transparent',
        '&.Mui-selected': {
          backgroundColor: '#F59C1E',
          color: 'white',
        },
        '&:hover': {
          backgroundColor: 'primary.light',
        },
      }}
    />
  );
};

const BarChartComponent = ({ bardata, maxValue, color }) => (
  <Box sx={{ backgroundColor: '#ffffff', borderRadius: 2 }}>
    <ResponsiveContainer
      width='100%'
      height={300}
    >
      <BarChart
        data={bardata}
        margin={{ top: 10, right: 20, left: 30, bottom: 30 }}
      >
        <XAxis
          dataKey='month'
          label={{
            value: 'Months',
            position: 'bottom',
            offset: 5,
          }}
         
        />
        <YAxis
          // domain={[0, maxValue]}
          label={{
            value: 'Sales',
            angle: -90,
            offset: -20,
            position: 'insideLeft',
          }}
          
          width={25}
        />
        <Tooltip />
        <Bar
          dataKey='sales'
          fill={color}
          barSize={window.innerWidth < 600 ? 15 : 20}
          background={{ fill: '#eee', radius: [10, 10, 0, 0] }}
          radius={[10, 10, 0, 0]}
        />
      </BarChart>
    </ResponsiveContainer>
  </Box>
);

const BarGraphSalesAnalysis = ({ analysisData }) => {
  const [bardata, setBardata] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState(3);
  const [maxValue, setMaxValue] = useState(0);
  const isMobile = useMediaQuery('(max-width: 1200px)');

  useEffect(() => {
    if (selectedFilter !== null && analysisData?.chart_info?.month_wise_sales) {
      const filteredData =
        analysisData.chart_info.month_wise_sales
          ?.slice(-selectedFilter)
          .map((item) => ({
            sales: item.sales,
            month: item.month_label,
          })) || [];

      if (filteredData.length > 0) {
        const maxSalesValue = Math.max(
          ...filteredData.map((item) => item.sales),
        );
        setMaxValue(maxSalesValue + 20);
        setBardata(filteredData);
      }
    }
  }, [selectedFilter, analysisData]);

  // useEffect(() => {
  //   if (analysisData?.chart_info?.month_wise_sales) {
  //     const salesData = analysisData.chart_info.month_wise_sales.map(
  //       (item) => ({
  //         sales: item.sales,
  //         month: item.month_label,
  //       }),
  //     );
  //     setBardata(salesData);
  //   }
  // }, [analysisData]);

  return (
    <Card sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
      <Grid
        container
        alignItems='center'
        justifyContent='space-between'
        sx={{ mb: 2 }}
      >
        <Typography sx={{ fontSize: 20, fontWeight: '600' }}>
          {analysisData?.section_header_display_title || 'Sales Analysis'}
        </Typography>
        {isMobile && analysisData?.chart_months_filter_info ? (
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel id="month-filter-label">Select Month</InputLabel>
            <Select
              labelId="month-filter-label"
              value={selectedFilter}
              onChange={(e) => {
                const selectedValue = e.target.value;
                setSelectedFilter(selectedValue);
                const index = analysisData?.chart_months_filter_info?.findIndex(option => option.value === selectedValue);
                setSelectedTab(index);
              }}
              label="Select Month"
            >
              {analysisData?.chart_months_filter_info?.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.display_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ):(
          <Tabs
            value={selectedTab}
            onChange={(event, newValue) => setSelectedTab(newValue)}
            textColor='primary'
            sx={{
              backgroundColor: '#F9F9F9',
              borderRadius: '16px',
              '& .MuiTabs-flexContainer': { display: 'flex', flexWrap: 'wrap' },
            }}
          >
            {analysisData?.chart_months_filter_info?.map((option, index) => (
              <TabButton
                key={option.value}
                index={index}
                label={option.display_name}
                selectedTab={selectedTab}
                onTabChange={setSelectedTab}
                onClick={() => setSelectedFilter(option.value)}
                isSelected={selectedTab === index}
              />
            ))}
          </Tabs>
        )
        }
      </Grid>

      {analysisData?.chart_info?.month_wise_sales ? (
        <BarChartComponent
          bardata={bardata}
          maxValue={maxValue}
          color={analysisData?.color}
        />
      ) : (
        <Grid
          container
          justifyContent='center'
          alignItems='center'
          sx={{ height: '100%', minHeight: 200 }}
        >
          <Box textAlign='center'>
            <ErrorOutline sx={{ fontSize: 60, color: '#B2B5C4' }} />
            <Typography
              sx={{ fontSize: 16, fontWeight: 600, color: '#8E92A8', mt: 1 }}
            >
              No Data Found
            </Typography>
          </Box>
        </Grid>
      )}
    </Card>
  );
};

export default BarGraphSalesAnalysis;
